export default __webpack_public_path__ + "static/media/Flag_of_Moldova.83f6c384.svg";